<script lang="ts">
    import { fly } from 'svelte/transition';

    export let title = "Servicio";
    export let description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";
    export let imageUrl = "images/redcost/placeholder.png";
    export let link = "#";
    export let ctaText = "CONOCER MÁS";

</script>


<!-- <a href={link} class="flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow-sm md:flex-row md:max-w-xl hover:bg-gray-100">
    <img class="object-cover w-full rounded-t-lg h-96 md:h-auto md:w-48 md:rounded-none md:rounded-s-lg" src={imageUrl} alt="">
    <div class="flex flex-col justify-between p-4 leading-normal">
        <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900">{title}</h5>
        <p class="mb-3 font-normal text-gray-700 ">{description}</p>
    </div>
</a> -->


<div class="category-card group overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-0  rounded-md shadow-md"
    in:fly|global="{{ y: 50, duration: 2000, delay: 600 }}">
      <div class="relative overflow-hidden">
        <img 
          src={imageUrl} 
          alt={title}
          class="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>
      <div class="p-6">
        <h3 class="text-2xl font-bold text-gray-800 mb-3 group-hover:text-amber-600 transition-colors duration-300">
          {title}
        </h3>
        <p class="text-gray-600 mb-6 leading-relaxed">
          {description}
        </p>
        <!-- <button           
          class="w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-semibold py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105"
        > -->

        <a href={link} class="block text-center w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-semibold py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105">
          {ctaText}
        </a>
        <!-- </button> -->
    </div>
</div>